module.exports = __webpack_public_path__ + "static/media/landmark_color.80ae99c3.jpg";